export default __webpack_public_path__ + "static/media/729.d53e671e.png";